import { useEffect, useState, useRef } from "react";
import { Col, Row, Overlay, Button, Popover } from "react-bootstrap";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import FormikControl from "../../../layouts/Input/FormikControl";
import storage from "../../../apis/Storage";
import Moment from "react-moment";
import {
  GET_DISTRIBUTOR_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
} from "../../../Types";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { Link } from "react-router-dom";
import {
  getDropdownList,
  getDropdownListByPost,
} from "../../Shared/dropdownListActions";
import { getDataListing, downloadJob } from "./VLConnectDetailReportActions";
import { isPermittedPage } from "../../../apis/Utility";
import { formatDate,toCommaSeparated } from "../../../utilities/FUNCTIONS";

const VLConnectDetailReport = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));

  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  const [currentIndex, setCurrentIndex] = useState();
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  const [distributorList, setDistributorList] = useState([]);
  const [distCenterList, setdistCenterList] = useState([]);

  const queryTypeOptions = [
    { label: "Information", value: "1" },
    { label: "Online Order", value: "2" },
    { label: "Complaint", value: "3" },
    { label: "Others", value: "4" },
  ];

  const queryStatusOptions = [
    { label: "Resolved", value: "Resolved" },
    { label: "Unresolved", value: "Unresolved" },
  ];

  const [filter, setfilter] = useState({
    distributor: [],
    distCenter: [],
    city: "",
    vizId: "",
    queryType: null,
    queryStatus: null,
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    searchText: null,
  });

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  function commonReset(reset = true) {
    if (reset) {
      setfilter({
        distributor: [],
        distCenter: [],
        city: "",
        vizId: "",
        queryType: null,
        queryStatus: null,
        fromDate: new Date(),
        toDate: new Date(),
        pageNo: 0,
        searchText: null,
      });
      setdistCenterList([]);
    }
  }

  function formRequestObject() {
    let requestData = {
      distributorId: toCommaSeparated(filter.distributor),
      distCenterId: toCommaSeparated(filter.distCenter),
      city: filter.city,
      vizId: filter.vizId,
      queryType: filter.queryType?.value,
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.toDate && formatDate(filter.toDate),
      status: filter.queryStatus?.value, // FIX
      SearchText: searchText, // FIX
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      IsExport: false,
    };

    if (requestData.distributorId == null) {
      if (
        userRights &&
        (userRights.userType === "DistributorUser" ||
          userRights.userType === "CoreAppUser")
      ) {
        requestData.distributorId = toCommaSeparated(userRights.distributorId);
      }
    }
    return requestData;
  }

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorListOptions = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId,
      );
      setDistributorList(
        distributorListOptions.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else if (userRights != null && userRights?.userType == "CoreAppUser") {
      let distributorListOptions = props.allDistributorList.filter((x) =>
        userRights?.distributorId.includes(x.value),
      );
      setDistributorList(
        distributorListOptions.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else {
      setDistributorList(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.allDistributorList]);

  function fetchReportData(request) {
    let finalRequest = request == null ? formRequestObject() : request;
    props.getDataListing(finalRequest);
  }

  const handleResetFilters = (resetForm) => {
    resetForm();
    commonReset();
  };

  const getData = (page) => {
    setCurrentPageNo(page);

    var request = { ...formRequestObject(), pageNo: page };

    fetchReportData(request);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);

    setCurrentPageSize(pageSize);

    var request = { ...formRequestObject(), pageSize: pageSize };

    fetchReportData(request);
  };

  const searchChanged = (text) => {
    setSearchText(text);
  };

  const LoadDataByfilter = () => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
  };

  useEffect(() => {
    setCurrentPageNo(0);
    fetchReportData();
  }, [searchText]);

  useEffect(() => {
    if (props.report && props.report.totalRecords > 0) {
      setTotalRecords(props.report.totalRecords);
    } else {
      setTotalRecords(0);
    }
  }, [props.report]);

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL,
    );
  }, []);

  useEffect(() => {
    setdistCenterList(
      props.selectedAddJobDistCentersList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      }),
    );
  }, [props.selectedAddJobDistCentersList]);

  useEffect(() => {
    if (!filter.distributor || filter.distributor.length > 0) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        { distributorIds: toCommaSeparated(filter.distributor) },
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
      );
    }
  }, [filter.distributor]);

  const Download = () => {
    props.downloadJob(formRequestObject());
  };

  const columns = [
    { Header: "Distributor", accessor: "distributor" },
    { Header: "Dist Center", accessor: "distCenter" },
    {
      Header: "Date",
      accessor: "date",
      Cell: (row) => <Moment format="DD/MM/YYYY">{row.value}</Moment>,
    },
    { Header: "VIZ ID", accessor: "vizId" },
    { Header: "Shop Name", accessor: "shopName" },
    { Header: "CNIC", accessor: "cnic" },
    { Header: "Query Type", accessor: "queryType" },
    { Header: "Status", accessor: "status" },
  ];
  return (
    <div>
      <VzPageContainer title="VL Connect Detail Report">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>VL Connect Detail Report</b>
            </h4>
            <br />
          </Col>
        </Row>

        <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>
              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
              >
                <Popover style={{ maxWidth: "360px", width: "360px" }}>
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distributor"
                                name="distributor"
                                options={distributorList}
                                isMulti={true}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    distributor: e || [],
                                    distCenter: []
                                  });
                                }}
                                value={filter.distributor}
                              />
                            </Col>

                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distribution Center"
                                name="distCenter"
                                options={distCenterList}
                                isMulti={true}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    distCenter: e || [],
                                  });
                                }}
                                value={filter.distCenter}
                              />
                            </Col>

                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="City"
                                name="city"
                                handleOnChange={(value) => {
                                  setfilter({
                                    ...filter,
                                    city: value,
                                  });
                                }}
                                value={filter.city}
                              />
                            </Col>

                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Query Type"
                                name="queryType"
                                options={queryTypeOptions}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    queryType: e,
                                  });
                                }}
                                value={filter.queryType}
                              />
                            </Col>

                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Query Status"
                                name="queryStatus"
                                options={queryStatusOptions}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  setfilter({
                                    ...filter,
                                    queryStatus: e,
                                  });
                                }}
                                value={filter.queryStatus}
                              />
                            </Col>

                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="VIZ ID"
                                name="vizId"
                                handleOnChange={(value) => {
                                  setfilter({
                                    ...filter,
                                    vizId: value,
                                  });
                                }}
                                value={filter.vizId}
                              />
                            </Col>
                            <Row style={{ paddingRight: 0 }}>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  formik={formik}
                                  type="fromDate"
                                  control="date"
                                  label="From Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, fromDate: value });
                                  }}
                                  value={filter.fromDate}
                                />
                              </Col>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  control="date"
                                  type="toDate"
                                  label="To Date"
                                  name="toDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, toDate: value });
                                  }}
                                  value={filter.toDate}
                                />
                              </Col>
                            </Row>
                          </Row>

                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm,
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>

                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>

                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>

          {isPermittedPage("Export", props.actions, props.userRole) && (
            <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={Download}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-download me-1" />
                Export
              </Button>
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <ServerSideDataTable
              data={props.report?.data ?? []}
              columns={columns}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    report: state.VLConnectDetailReport,
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    selectedAddJobDistCentersList: state.ddlList.selectedAddJobDistCentersList
      ? state.ddlList.selectedAddJobDistCentersList
      : [],
  };
};

export default connect(mapStateToProps, {
  getDataListing,
  getDropdownList,
  getDropdownListByPost,
  downloadJob,
})(VLConnectDetailReport);
